import { PhoneField } from "client/lib/apt-merchant/src/fields/storeDetails/PhoneField";

import { Merchant } from "../../merchant";
import { CountryList, MerchantField } from "../../types";

const testValueByCountryMap: Record<CountryList, string> = {
  "United Kingdom": "+441234567900",
  "United States": "+18003334444",
  "New Zealand": "+641234567890",
  Canada: "+12041234567",
  Australia: "+61123456789",
};

export class CustomerSupportPhoneField extends PhoneField {
  constructor(model: Merchant, opts: Partial<MerchantField<string>> = {}) {
    super(model, {
      dataType: "string",
      testValue: "+18003334444",
      propertyName: "customerSupportPhone",
      uiFieldType: "Phone",
      uiInputBaseProps: {
        autoComplete: "tel",
      },
      applicable: true,
      required: true,
      shown: true,
      ...opts,
    });
  }

  get testValue(): string {
    const registeredCountry = this._model.lead.registeredCountry.value;
    return registeredCountry
      ? testValueByCountryMap[registeredCountry]
      : "+18003334444";
  }
}
